import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { ADVERTISEMENTS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const updateAdvertisementsDisplayOrderAction = createAsyncThunk(
    'pod/updateAdvertisementsDisplayOrderAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.patch(`${ ADVERTISEMENTS_PATH }/display-order`, data);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const updateAdvertisementsDisplayOrderSlice = createSlice({
    name: 'updateAdvertisementsDisplayOrderSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(updateAdvertisementsDisplayOrderAction.pending, () => STATE__API__STARTED);
        builder.addCase(updateAdvertisementsDisplayOrderAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(updateAdvertisementsDisplayOrderAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const updateAdvertisementsDisplayOrderState = (state) => state.pod.updateAdvertisementsDisplayOrder;
export default updateAdvertisementsDisplayOrderSlice.reducer;